import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const KEY = "estoico_offer_deadline";
const DURATION = 24 * 60 * 60 * 1000;

const readDeadline = () => {
  try {
    const saved = Number(localStorage.getItem(KEY));
    if (saved && saved > Date.now()) return saved;
  } catch {}
  const deadline = Date.now() + DURATION;
  try {
    localStorage.setItem(KEY, String(deadline));
  } catch {}
  return deadline;
};

const format = (ms) => {
  const total = Math.floor(ms / 1000);
  const h = String(Math.floor(total / 3600)).padStart(2, "0");
  const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

export const CountdownTimer = ({ variant = "compact" }) => {
  const [deadline, setDeadline] = useState(readDeadline);
  const [remaining, setRemaining] = useState(deadline - Date.now());

  useEffect(() => {
    const tick = setInterval(() => {
      const left = deadline - Date.now();
      if (left <= 0) {
        const fresh = Date.now() + DURATION;
        try {
          localStorage.setItem(KEY, String(fresh));
        } catch {}
        setDeadline(fresh);
        setRemaining(fresh - Date.now());
      } else {
        setRemaining(left);
      }
    }, 1000);
    return () => clearInterval(tick);
  }, [deadline]);

  if (variant === "compact") {
    return (
      <span
        data-testid="offer-countdown"
        className="hidden md:flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#d4af37]/80"
      >
        <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
        Termina em <span className="text-[#f5d77f] tabular-nums">{format(remaining)}</span>
      </span>
    );
  }

  return (
    <div
      data-testid="offer-countdown-full"
      className="inline-flex flex-col items-center gap-2 rounded-2xl border border-[#d4af37]/25 bg-[#14141a]/80 px-8 py-5"
    >
      <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d4af37] flex items-center gap-2">
        <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
        A oferta de lançamento termina em
      </span>
      <span className="font-mono text-3xl sm:text-4xl font-medium text-[#f5d77f] tabular-nums tracking-wider">
        {format(remaining)}
      </span>
    </div>
  );
};
